import { Badge } from '@/components/ui/badge'
import type { SeverityLevel } from '@/types/alert.types'

interface AlertBadgeProps {
  severity: SeverityLevel
}

export const AlertBadge = ({ severity }: AlertBadgeProps) => {
  const severityConfig = {
    info: { label: 'Info', variant: 'info' as const },
    warning: { label: 'Warning', variant: 'warning' as const },
    critical: { label: 'Critical', variant: 'destructive' as const }
  }

  const config = severityConfig[severity] || severityConfig.info

  return <Badge variant={config.variant}>{config.label}</Badge>
}
